export enum WasteStreamUseStatus {
  ACTIVE = "active",
  NOT_USED = "not_used",
  RECOMMENDED = "recommended",
}

export type WasteStreamWithUse = {
  id: string;
  name: string;
  status?: WasteStreamUseStatus;
  icon: string;
};
